export default __webpack_public_path__ + "ec324ada767d29c5b6ba83564237789a.png";